import { render } from "./MyAddress.vue?vue&type=template&id=d9384050&scoped=true"
import script from "./MyAddress.vue?vue&type=script&lang=js"
export * from "./MyAddress.vue?vue&type=script&lang=js"

import "./MyAddress.vue?vue&type=style&index=0&id=d9384050&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9384050"]])

export default __exports__